module.exports = (__webpack_require__(8))(295);


//////////////////
// WEBPACK FOOTER
// delegated ../node_modules/babel-runtime/core-js/object/assign.js from dll-reference vendors
// module id = 2017
// module chunks = 0